<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 标题 -->
    <div class="el_div">
      <el-button
      @click.native.prevent='addRow()'
      v-if="btn_permission.includes('sys:menu:add')||btn_permission.includes('superAdmin')"
      type="primary">添加权限</el-button>
    </div>
    <!-- 权限列表 -->
    <el-table
    :data="listData"
    highlight-current-row
    row-key="id"
    :tree-props="{children:'child'}"
    border
    max-height="500"
    style="padding-bottom: 1px;"
    >
      <el-table-column align="center" type="index"></el-table-column>
      <el-table-column width="180px" show-overflow-tooltip label="权限名称">
        <template slot-scope='scope'>
          <icon-svg v-show="scope.row.css!=''" :iconClass="scope.row.css"/>
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="permission" label="权限标识"></el-table-column>
      <el-table-column width="300px" show-overflow-tooltip prop="uri" label="菜单url"></el-table-column>
      <el-table-column width="80px" prop="sort" label="排序"></el-table-column>
      <el-table-column width="100px" align="center" label="类型">
        <template slot-scope="scope">
          <el-tag v-show="scope.row.type==3" effect="dark">忽略校验</el-tag>
          <el-tag v-show="scope.row.type==2" effect="dark">按钮</el-tag>
          <el-tag v-show="scope.row.parentId==-1" effect="light">目录</el-tag>
          <el-tag v-show="scope.row.parentId!=-1&&scope.row.type==1" effect="plain">菜单</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="250px" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-tag
          class="operate"
          effect="dark"
          @click="addRow(scope.row)"
          v-if="scope.row.type==1&&btn_permission.includes('sys:menu:add')||scope.row.type==1&&btn_permission.includes('superAdmin')"
          >
            添加权限
          </el-tag>
          <el-tag
          class="operate"
          effect="dark"
          type="success"
          @click="editRow(scope.row)"
          v-if="btn_permission.includes('sys:menu:edit')||btn_permission.includes('superAdmin')"
          >
            编辑
          </el-tag>
          <el-tag
          class="operate"
          effect="dark"
          type="success"
          v-if="scope.row.status==0"
          @click='open_close(scope.row)'
          >启用</el-tag>
          <el-tag
          class="operate"
          effect="dark"
          type="danger"
          v-if="scope.row.status==1"
          @click='open_close(scope.row)'
          >禁用</el-tag>
          <el-tag
          class="operate"
          effect="plain"
          v-if="btn_permission.includes('sys:menu:del')||btn_permission.includes('superAdmin')"
          @click='close_role(scope.row)'
          >
            删除
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
   <!-- 添加权限弹框 -->
   <el-dialog
   :title="role_title"
   :append-to-body='true'
   :close-on-click-modal='false'
   :visible.sync="newRole_visible"
   >
   <!-- 样式弹框 -->
   <el-dialog
   :append-to-body='true'
   title="选择样式"
   :visible.sync="style_visible"
   width="80%"
   >
     <iframe style="width: 100%;height: 350px;" :src="'./static/font_2877484/demo_index.html?auth_token='+upload_token"></iframe>
   </el-dialog>
    <el-form
    ref="roleForm"
    :model="roleForm"
    label-width="100px"
    :rules="rules"
    >
      <el-form-item label="上级菜单">
        <el-input v-model="parentName" :readonly='true'></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input placeholder="请输入名称" v-model="roleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="样式" prop="css">
        <el-input placeholder="请双击选择样式" v-model="roleForm.css" @dblclick.native="choose_style()"></el-input>
      </el-form-item>
      <el-form-item label="链接" prop="href">
        <el-input placeholder="请输入链接" v-model="roleForm.href"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select placeholder="请选择类型" v-model="roleForm.type" style="width: 100%;">
          <el-option label="菜单" :value="1"></el-option>
          <el-option label="按钮" :value="2"></el-option>
          <el-option label="忽略校验" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="权限" prop="permission">
        <el-input v-model="roleForm.permission"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input placeholder="请输入排序" type="number" v-model="roleForm.sort"></el-input>
      </el-form-item>
      <el-form-item v-show="roleForm.type==2" label="请求URI" prop="uri">
        <el-input placeholder="请输入请求URI" v-model="roleForm.uri"></el-input>
      </el-form-item>
      <el-form-item v-show="roleForm.type==2" label="校验数据权限" prop="dataCheck">
        <el-radio-group v-model="roleForm.dataCheck">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="roleForm.type==2" label="校验仓库权限" prop="warehouseCheck">
        <el-radio-group v-model="roleForm.warehouseCheck">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="roleForm.type==2" label="校验货主权限" prop="customerCheck">
        <el-radio-group v-model="roleForm.customerCheck">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit_role()">提交</el-button>
        <el-button @click="reset_role()">重置</el-button>
      </el-form-item>
    </el-form>
   </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        upload_token:localStorage.getItem(localStorage.getItem('userName')+'token'),
        newRole_visible:false,//新增权限弹框
        style_visible:false,//选择样式弹框
        parentName:'root',
        //权限表单
        roleForm:{
          parentId:-1,
          name:'',
          css:'',
          href:'',
          type:'',
          permission:'',
          sort:'',
          uri:'',
          dataCheck:false,
          warehouseCheck:false,
          customerCheck:false
        },
        //表单正则
        rules:{
          name:[
            {required:true,message:'请输入名称',trigger:'blur'}
          ],
          type:[
            {required:true,message:'请选择类型',trigger:'change'}
          ],
          sort:[
            {required:true,message:'请输入排序',trigger:'blur'}
          ]
        },
        listData:[],
        role_title:'新增权限',//权限弹框标题
        change_id:''//权限ID
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //权限列表
      that.role_list()
    },
    mounted() {

    },
    methods:{
      //权限列表
      role_list(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/permission/treeTable'
        }).then(data=>{
          if(data.data.success==true){
            //获取当前用户按钮权限
            that.$axios({
              method:'get',
              url:that.publicAjax.extra_path+'/admin/user/permission'
            }).then(data=>{
              if(data.data.success==true){
                that.btn_permission=data.data.data
              }else{
                that.$message.error(data.data.message)
              }
            })
            that.listData=data.data.data
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //添加权限前置
      addRow(row){
        let that=this
        that.newRole_visible=true
        that.role_title='新增权限'
        if(that.$refs['roleForm']!=undefined){
          that.$refs['roleForm'].resetFields()
        }
        if(row==undefined){
          that.roleForm.parentId=-1
          that.parentName='root'
        }else{
          that.roleForm.parentId=row.id
          that.parentName=row.name
        }
      },
      //选择样式
      choose_style(){
        this.style_visible=true
      },
      //提交权限表单
      submit_role(){
        let that=this
        that.$refs['roleForm'].validate((valid)=>{
          if(valid){
            if(that.role_title=='新增权限'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/admin/permission',
                data:that.roleForm,
                headers:{
                  "client": "web", //电脑浏览器:web,手机:mobile
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
                  "content-type":"application/json;charset=UTF-8"
                }
              }).then(data=>{
                if(data.data.success==true){
                  that.$message.success(data.data.message)
                  //权限列表
                  that.role_list()
                  that.newRole_visible=false
                }else{
                  that.$message.error(data.data.message)
                }
              })
            }else if(that.role_title=='修改权限'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/admin/permission/'+that.change_id,
                data:that.roleForm,
                headers:{
                  "client": "web", //电脑浏览器:web,手机:mobile
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
                  "content-type":"application/json;charset=UTF-8"
                }
              }).then(data=>{
                if(data.data.success==true){
                  that.$message.success(data.data.message)
                  //权限列表
                  that.role_list()
                  that.newRole_visible=false
                }else{
                  that.$message.error(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //重置权限表单
      reset_role(){
        this.$refs['roleForm'].resetFields()
      },
      //修改权限前置
      editRow(row){
        let that=this
        that.newRole_visible=true
        that.role_title='修改权限'
        if(that.$refs['roleForm']!=undefined){
          that.$refs['roleForm'].resetFields()
        }
        that.change_id=row.id
        //根据ID回显权限
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/permission/detail/'+row.id
        }).then(data=>{
          if(data.data.success==true){
            if(data.data.data.parentId==-1){
              that.roleForm.parentId=-1
              that.parentName='root'
            }else{
              that.$axios({
                method:'get',
                url:that.publicAjax.extra_path+'/admin/permission/detail/'+data.data.data.parentId
              }).then(data=>{
                if(data.data.success==true){
                  that.roleForm.parentId=data.data.data.id
                  that.parentName=data.data.data.name
                }else{
                  that.$message.error(data.data.message)
                }
              })
            }
            that.roleForm.name=data.data.data.name
            that.roleForm.css=data.data.data.css
            that.roleForm.href=data.data.data.href
            that.roleForm.type=data.data.data.type
            that.roleForm.permission=data.data.data.permission
            that.roleForm.sort=data.data.data.sort
            that.roleForm.uri=data.data.data.uri
            that.roleForm.dataCheck=data.data.data.dataCheck
            that.roleForm.warehouseCheck=data.data.data.warehouseCheck
            that.roleForm.customerCheck=data.data.data.customerCheck
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //启用或禁用权限
      open_close(row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          if(row.status==0){
            //启用权限
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/permission/active/'+row.id
            }).then(data=>{
              if(data.data.success==true){
                //权限列表
                that.role_list()
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }else{
            //禁用权限
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/permission/disable/'+row.id
            }).then(data=>{
              if(data.data.success==true){
                //权限列表
                that.role_list()
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }
        }).catch(()=>{

        })
      },
      //删除权限
      close_role(row){
        let that=this
        that.$confirm('数据可能无法恢复,请谨慎操作！','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/admin/permission/'+row.id
          }).then(data=>{
            if(data.data.success==true){
              //权限列表
              that.role_list()
              that.$message.success(data.data.message)
            }else{
              that.$message.error(data.data.message)
            }
          })
        }).catch(()=>{

        })
      }
    }
  }
</script>

<style scoped="scoped">
  .el_div{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 20px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .operate{
    margin-bottom: 2px;
    cursor: pointer;
  }
  .operate:nth-child(1){
    background: #409EFF;
    border: #409EFF;
  }
  .el-form{
    height: 350px;
    overflow: hidden;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/menu.vue